import {
  Box,
  Container,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  inputSpacing: {
    marginBottom: "10px",
  },
}));

const NoPermission = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="sm" style={{ paddingTop: "8rem" }}>
      <Paper>
        <Box p="2rem" style={{ textAlign: "center" }}>
          <AppBar position="static" style={{ marginBottom: "1rem" }}>
            <div
              className={classes.logoAvatar}
              style={{
                backgroundColor: "#ff726f",
                textAlign: "center",
                padding: "0.3rem",
              }}
            >
              <ErrorOutlineOutlinedIcon />
              <Typography variant="h4">Sorry! Access Denied.</Typography>
            </div>
          </AppBar>

          <Typography variant="option" style={{ marginTop: "1rem" }}>
            You don't have permission to access this page.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

const withConnect = connect(null, null);

export default compose(withConnect)(NoPermission);
